import { debounce } from 'lodash'

export const debounced = debounce
